webpackJsonp([142629428675168],{

/***/ 896:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"languages":{"defaultLangKey":"ru","langs":["en","ru"]}}}},"pathContext":{"slug":"/","langKey":"ru"}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-1b5902499b9975b52121.js